import Vue from "vue";
import {DirectiveBinding} from "vue/types/options";

function clearErrors(element: HTMLElement) {
    element.className = element.className.replaceAll('is-invalid', '').trim();
    while (element.nextElementSibling?.className.includes('invalid-feedback')) {
        element.nextElementSibling.remove();
    }
}

function validateBinding(binding: DirectiveBinding) {
    if (!Array.isArray(binding.value)) {
        throw new Error('v-validation binding: "' + binding.expression + '" is not an array. Instead it is a type of "' + typeof(binding.value) + '"');
    }

    binding.value.forEach(message => {
        if (typeof message !== 'string') {
            throw new Error('v-validation binding: "' + binding.expression + '" contains a non-string item. Incorrect type: "' + typeof(message) + '", expected: "string"');
        }
    });
}

function updateErrors(element: HTMLElement, binding: DirectiveBinding) {
    clearErrors(element);
    
    validateBinding(binding);
    
    if (binding.value.length === 0) {
        return;
    }
    
    element.className = element.className + " is-invalid";

    (binding.value as string[]).forEach(message => {
        const errorDiv = document.createElement('div');
        errorDiv.className = "invalid-feedback";
        errorDiv.append(message);
        element.after(errorDiv);
    });

}

Vue.directive("validation", {
    componentUpdated: (
        element: HTMLElement,
        binding: DirectiveBinding
    ) => {
        updateErrors(element, binding);
    }})
